import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import {
  Card,
  Stack,
  Typography,
  TextField,
  IconButton,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";

const MOCK_REPORTS = [
  {
    id: 1,
    orderNumber: "MLKIST-abc123xyz",
    orderType: "Kargo",
    creationDate: new Date("2025-09-28T14:30:00").toLocaleString("tr-TR"),
    status: "Oluşturuldu",
    pointID: "point123",
    senderName: "Ahmet",
    senderLastname: "Yılmaz",
    senderPhone: "5551234567",
    senderEmail: "ahmet.yilmaz@example.com",
    senderAddressCity: "İstanbul",
    senderAddressTown: "Beşiktaş",
    senderAddressDetails: "Barbaros Bulvarı No:1",
    receiverName: "Ayşe",
    receiverLastname: "Kaya",
    receiverAddressTown: "Kadıköy",
    receiverAddressCity: "İstanbul",
    receiverAddressNeighbour: "Caferağa",
    receiverAddressDetails: "Bahariye Caddesi No:2",
    receiverPhone: "5557654321",
    receiverEmail: "ayse.kaya@example.com",
    price: 120.5,
    productType: "Elektronik",
    receiverZipcode: "34710",
    paymentMethod: "online-payment",
    totalDeci: 5.5,
    partCount: 1,
  },
  {
    id: 2,
    orderNumber: "MLVG-def456uvw",
    orderType: "Kurye",
    creationDate: new Date("2025-09-29T10:15:00").toLocaleString("tr-TR"),
    status: "Teslim Edildi",
    pointID: "point123",
    senderName: "Mehmet",
    senderLastname: "Öztürk",
    senderPhone: "5559876543",
    senderEmail: "mehmet.ozturk@example.com",
    receiverNameLastname: "Fatma Şahin",
    receiverAddressTown: "Şişli",
    receiverAddressCity: "İstanbul",
    receiverAddressNeighbour: "Teşvikiye",
    receiverAddressDetails: "Valikonağı Caddesi No: 50",
    receiverAddressDefinition: "Nişantaşı City's AVM yanı",
    receiverPhone: "5551112233",
    price: 85.0,
    productType: "Belge",
    additionalNote: "Acele teslimat.",
    courierType: "MotorCourier",
    longitude: 29.0024,
    latitude: 41.0475,
    paymentMethod: 'cash-on-delivery'
  },
];

const mockApiService = {
  getOrderReports: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: { status: true, result: MOCK_REPORTS } });
      }, 1000);
    });
  },
};

const keyToLabelMap = {
    pointID: "Nokta ID",
    senderName: "Gönderici Adı",
    senderLastname: "Gönderici Soyadı",
    senderPhone: "Gönderici Telefon",
    senderEmail: "Gönderici E-posta",
    senderAddressCity: "Gönderici Şehir",
    senderAddressTown: "Gönderici İlçe",
    senderAddressDetails: "Gönderici Adres Detayı",
    receiverName: "Alıcı Adı",
    receiverLastname: "Alıcı Soyadı",
    receiverNameLastname: "Alıcı Adı Soyadı",
    receiverAddressTown: "Alıcı İlçe",
    receiverAddressCity: "Alıcı Şehir",
    receiverAddressNeighbour: "Alıcı Mahalle",
    receiverAddressDetails: "Alıcı Adres Detayı",
    receiverPhone: "Alıcı Telefon",
    receiverEmail: "Alıcı E-posta",
    price: "Fiyat",
    productType: "Ürün Tipi",
    receiverZipcode: "Alıcı Posta Kodu",
    paymentMethod: "Ödeme Yöntemi",
    totalDeci: "Toplam Desi",
    partCount: "Parça Sayısı/Detayı",
    receiverAddressDefinition: "Alıcı Adres Tarifi",
    additionalNote: "Ek Not",
    courierType: "Kurye Tipi",
    longitude: "Boylam",
    latitude: "Enlem",
    orderNumber: "Sipariş No",
    orderType: "Tür",
    creationDate: "Oluşturma Tarihi",
    status: "Durum",
};

export default function OrderReportPage() {
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("creationDate");
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  useEffect(() => {
    const fetchReports = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await mockApiService.getOrderReports();
        if (res.data.status && Array.isArray(res.data.result)) {
          setReports(res.data.result);
          setFilteredReports(res.data.result);
        } else {
          setReports([]);
          setFilteredReports([]);
          setError("Rapor verisi alınamadı.");
        }
      } catch (err) {
        setError("Raporlar yüklenirken bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };
    fetchReports();
  }, []);
  
  // ARAMA MANTIĞI GÜNCELLENDİ
  useEffect(() => {
    const lowercasedFilter = searchText.toLowerCase();
    const filteredData = reports.filter(item => {
      return (
        item.orderNumber?.toLowerCase().includes(lowercasedFilter) ||
        item.senderName?.toLowerCase().includes(lowercasedFilter) ||
        item.receiverName?.toLowerCase().includes(lowercasedFilter) ||
        item.receiverNameLastname?.toLowerCase().includes(lowercasedFilter)
      );
    });
    setFilteredReports(filteredData);
  }, [searchText, reports]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  
  const sortedReports = [...filteredReports].sort((a, b) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];
    
    if (orderBy === 'creationDate') {
        aValue = new Date(aValue.split('.').reverse().join('-').replace(" ", "T"));
        bValue = new Date(bValue.split('.').reverse().join('-').replace(" ", "T"));
    }

    if (bValue < aValue) return order === 'asc' ? 1 : -1;
    if (bValue > aValue) return order === 'asc' ? -1 : 1;
    return 0;
  });

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDetails = (report) => {
    setSelectedReport(report);
    setDetailsModalOpen(true);
  };

  const handleCloseDetails = () => {
    setDetailsModalOpen(false);
    setSelectedReport(null);
  };

  const columns = [
    { id: "orderNumber", label: "SİPARİŞ NO" },
    { id: "orderType", label: "TÜR" },
    { id: "senderName", label: "GÖNDERİCİ" },
    { id: "receiverName", label: "ALICI" },
    { id: "price", label: "TUTAR" },
    { id: "paymentMethod", label: "ÖDEME YÖNTEMİ" },
    { id: "creationDate", label: "OLUŞTURMA TARİHİ" },
    { id: "status", label: "DURUM" },
    { id: "actions", label: "DETAY", align: "center" },
  ];

  const renderDetailValue = (value) => {
    if (typeof value === 'object' && value !== null) {
      return (
        <Box component="pre" sx={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          <code>{JSON.stringify(value, null, 2)}</code>
        </Box>
      );
    }
    return String(value);
  };

  return (
    <>
      <Helmet>
        <title>Sipariş Cari Raporlama</title>
      </Helmet>
      <Stack style={{ padding: "25px" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
          borderBottom="1px solid rgba(235, 235, 235, 1)"
          paddingBottom={1.5}
        >
          <Typography variant="h4" sx={{ fontSize: "16px !important" }}>
            Sipariş Cari Raporlama
          </Typography>
        </Stack>

        <Box sx={{ backgroundColor: "white", pt: 2, boxShadow: 1, borderRadius: 1, mt: 3 }}>
          <Box sx={{ px: 2, mb: 3 }}>
            <TextField
              fullWidth
              placeholder="Sipariş no, gönderici veya alıcı adı ile ara..."
              variant="outlined"
              size="small"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              InputProps={{
                startAdornment: <IconButton><SearchIcon /></IconButton>,
              }}
              sx={{ maxWidth: "400px" }}
            />
          </Box>
          <Card sx={{ overflow: "auto" }}>
            <Table sx={{ minWidth: 1200 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align || "left"} sx={{ fontWeight: "bold", fontSize: "12px" }} sortDirection={orderBy === column.id ? order : false}>
                      <TableSortLabel active={orderBy === column.id} direction={orderBy === column.id ? order : "asc"} onClick={() => handleRequestSort(column.id)}>
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={columns.length} align="center"><CircularProgress /></TableCell></TableRow>
                ) : error ? (
                  <TableRow><TableCell colSpan={columns.length} align="center"><Alert severity="error">{error}</Alert></TableCell></TableRow>
                ) : (
                  sortedReports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                      <TableRow key={row.id} hover>
                        <TableCell>{row.orderNumber}</TableCell>
                        <TableCell>{row.orderType}</TableCell>
                        {/* TABLO VERİLERİ GÜNCELLENDİ */}
                        <TableCell>{`${row.senderName} ${row.senderLastname}`}</TableCell>
                        <TableCell>{row.receiverNameLastname || `${row.receiverName} ${row.receiverLastname}`}</TableCell>
                        <TableCell>{`${row.price.toFixed(2)} TL`}</TableCell>
                        <TableCell>{row.paymentMethod}</TableCell>
                        <TableCell>{row.creationDate}</TableCell>
                        <TableCell>{row.status}</TableCell>
                        <TableCell align="center">
                          <IconButton size="small" title="Tüm Veriyi Görüntüle" onClick={() => handleOpenDetails(row)}>
                            <DescriptionIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </Card>
        </Box>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredReports.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Stack>

      {/* DETAY MODALI GÜNCELLENDİ */}
      <Dialog open={detailsModalOpen} onClose={handleCloseDetails} maxWidth="sm" fullWidth>
        <DialogTitle>
          Sipariş Detayı: {selectedReport?.orderNumber}
          <IconButton sx={{ position: "absolute", right: 16, top: 16 }} onClick={handleCloseDetails}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedReport && (
            <List dense>
              {/* `selectedReport.payload` yerine `selectedReport` kullanılıyor */}
              {Object.entries(selectedReport).map(([key, value]) => {
                // `id` gibi teknik alanları modalda göstermeyelim.
                if (key === 'id') return null;
                return (
                  <ListItem key={key} sx={{ py: 1, borderBottom: '1px solid #eee' }} >
                    <ListItemText
                      primary={<strong>{keyToLabelMap[key] || key}:</strong>}
                      secondary={
                          <Typography component="span" variant="body2" color="text.primary">
                              {renderDetailValue(value)}
                          </Typography>
                      }
                      primaryTypographyProps={{ style: { minWidth: '180px', flexShrink: 0, marginRight: '16px' } }}
                      sx={{ display: 'flex', alignItems: 'flex-start' }}
                    />
                  </ListItem>
                )
              })}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetails}>Kapat</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}